<template>
  <div class="loading-overlay-container" :class="containerClass">
    <!-- Underlying content -->
    <slot />

    <!-- Loading overlay -->
    <transition name="fade">
      <div
        v-if="active"
        class="loading-overlay"
        :class="overlayClass"
        :style="overlayStyle"
        @click.stop
        @keydown.stop
      >
        <div class="loading-overlay__content">
          <slot name="loading">
            <LoadingSpinner :variant="spinnerVariant" :size="spinnerSize" :label="label" />
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'LoadingOverlay',
  components: {
    LoadingSpinner
  },
  props: {
    /**
     * Whether the overlay is active
     */
    active: {
      type: Boolean,
      default: false
    },
    /**
     * Background opacity (0-1)
     */
    opacity: {
      type: Number,
      default: 0.7
    },
    /**
     * Background color
     */
    backgroundColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.8)'
    },
    /**
     * Spinner variant
     */
    spinnerVariant: {
      type: String,
      default: 'primary'
    },
    /**
     * Spinner size
     */
    spinnerSize: {
      type: String,
      default: 'default'
    },
    /**
     * Accessibility label
     */
    label: {
      type: String,
      default: 'Loading...'
    },
    /**
     * Whether to show dark overlay (for light backgrounds)
     */
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerClass() {
      return {
        'loading-overlay-container': true,
        'loading-overlay-container--relative': !this.hasAbsolutePositioning
      }
    },
    overlayClass() {
      return {
        'loading-overlay': true,
        'loading-overlay--dark': this.dark
      }
    },
    overlayStyle() {
      return {
        backgroundColor: this.dark ? 'rgba(0, 0, 0, 0.7)' : this.backgroundColor,
        opacity: this.opacity
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-overlay-container {
  position: relative;
  min-height: 0;

  &--relative {
    position: relative;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: auto;

  &__content {
    z-index: 11;
  }

  &--dark {
    background: rgba(0, 0, 0, 0.7) !important;
  }
}

.fade-enter-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-active {
  transition: opacity 0.3s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>